export const ACHProcessorData = {
	ACHProcessor: {
		name: "achProcessor",
		displayName: "ACH Processor",
		beName: "achProcessor",
	},
	CustomerType: {
		name: "customerType",
		displayName: `Who are Your "Customers"?`,
		beName: "customer_type",

		Individuals: {
			value: "individuals",
			displayName: "Individuals",
		},
		Businesses: {
			value: "businesses",
			displayName: "Businesses",
		},
		Both: {
			value: "both",
			displayName: "Both - Individuals & Businesses",
		},
	},
	PaymentAuthorizationType: {
		name: "paymentAuthorizationType",
		displayName: "How Do You Receive Payment Authorization?",
		beName: "payment_authorization_type",

		SignedContract: {
			value: "signed_contract_or_agreement",
			displayName: "Signed Contract or Agreement",
		},
		Online: {
			value: "online_or_mobile_app",
			displayName: "Online or Mobile App",
		},
		Both: {
			value: "both",
			displayName:
				"Both - Signed Contract or Agreement & Online or Mobile App",
		},
	},
	MonthlyVolumeAch: {
		name: "monthlyVolumeAch",
		displayName: "Monthly Volume (ACH), $",
		beName: "monthly_volume_ach",
	},
	TicketCountAch: {
		name: "ticketCountAch",
		displayName: "Ticket Count (ACH)",
		beName: "ticket_count_ach",
	},
	HighTicketAch: {
		name: "highTicketAch",
		displayName: "High Ticket (ACH), $",
		beName: "high_ticket_ach",
	},
	MonthlyVolumeAchPayouts: {
		name: "monthlyVolumeAchPayouts",
		displayName: "Monthly Volume (ACH Payouts), $",
		beName: "monthly_volume_ach_payouts",
	},
	TicketCountAchPayouts: {
		name: "ticketCountAchPayouts",
		displayName: "Ticket Count (ACH Payouts)",
		beName: "ticket_count_ach_payouts",
	},
	HighTicketAchPayouts: {
		name: "highTicketAchPayouts",
		displayName: "High Ticket (ACH Payouts), $",
		beName: "high_ticket_ach_payouts",
	},
	IsApplyBankAccountData: {
		name: "isApplyBankAccountData",
		displayName: "Use This Account for ACH Service Fees Collection?",
		displayNameForView: "ACH Service Fees Collection Account Details",
		beName: "is_apply_bank_account_data",

		Yes: {
			value: "true",
			displayName: "Yes",
			beName: true,
		},
		No: {
			value: "false",
			displayName: "No",
			beName: false,
		},
	},
	BillingRouting: {
		name: "billingRouting",
		displayName: "Billing Routing",
		beName: "billing_routing",
	},
	BillingBank: {
		name: "billingBank",
		displayName: "Billing Bank",
		beName: "billing_bank",
	},
	BillingAccount: {
		name: "billingAccount",
		displayName: "Billing Account",
		beName: "billing_account",
	},
	BillingAccountName: {
		name: "billingAccountName",
		displayName: "Billing Account Name",
		beName: "billing_account_name",
	},
	StatementDescriptor: {
		name: "statementDescriptor",
		displayName: "Statement Descriptor",
		beName: "statement_descriptor",
		tooltip:
			"We already pass along your company name and customer service number, so consider some other value here. 10 character max",
	},
	UseOfPaymentServiceDescription: {
		name: "useOfPaymentService",
		displayName: "Use of Payment Service",
		beName: "use_of_payment_service_description",
		tooltip:
			"Examples include payroll, service fees, sale of goods, subscription fee, tuition, etc.",
	},
	StatementSetup: {
		displayName: "Statement Setup",
		tooltip:
			"This information may be visible on bank statements, emails, and receipts",
	},
	StraddleIdentifier: {
		name: "straddleIdentifier",
		displayName: "Straddle Identifier",
		beName: "straddle_identifier",
	},
};
